import React from 'react';
import './Reviews.css';

const reviews = [
  {
    name: "Matt D.",
    review:
      "Mark was both insightful and highly observant throughout our sessions. I was initially skeptical about how effective online coaching could be, but he quickly proved that he could pick up on subtle communication cues like tone, body language, and pacing even over video. His constructive feedback during mock interviews was incredibly valuable. Mark played a key role in helping me secure a Police Constable position with an Ontario Police Service.",
  },
  {
    name: "Trevor M.",
    review:
      "Mark is a clear and effective communicator. He explained his techniques and strategies in a way that was easy to understand and apply. He was also personable and easy to work with, which made each session comfortable and productive. Thanks to his guidance, I successfully secured a position in Corrections in Ontario.",
  },
  {
    name: "Connor E.",
    review:
      "Working with Mark was a game-changer. His passion for coaching was clear from day one. I could tell he genuinely cared about helping me reach my goal. He was always available when I needed support and stayed positive and encouraging, even when I had doubts. Mark was focused, diligent, and fully invested throughout the entire process. With his guidance, I secured a position on the SWAT team with a Police Service in Ontario.",
  },
];

const Reviews = () => {
  return (
    <div className="reviews">
      <h1 className="reviews-title">What Clients Are Saying</h1>
      <p className="reviews-subtitle">
        Real feedback from professionals who trusted Bulletproof Interview Coaching.
      </p>
      <div className="reviews-container">
        {reviews.map((r, i) => (
          <div key={i} className="review-card">
            <div className="stars">★★★★★</div>
            <p className="review-text">"{r.review}"</p>
            <p className="review-author">— {r.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
